import { List } from "antd-mobile";
import React, { useContext, useEffect, useState } from "react";
import PsContext from "../../context";
import { _OpenPaymentFees } from "../../models/pay";
import { groupByMultiple, momentDate } from "../../utils";

const PaymentHistory = (props) => {
  const context = useContext(PsContext);
  const [unpaid, setUnpaid] = useState([]);

  const [student, setStudent] = useState(props.student);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadUnPaid();
  }, []);

  const loadUnPaid = () => {
    setLoader(true);
    context.setLoader(true);
    _OpenPaymentFees({
      uuid: student.uuid,
      id: student.id,
      type: "paid",
    }).then((res) => {
      if (res.status == "1") {
        let s = groupByMultiple(res.data, function (obj) {
          return [obj.bill_uuid];
        });
        setUnpaid(s);
      }
      context.setLoader(false);
      setLoader(false);
    });
  };

  return (
    <>
      {!loader && unpaid.length < 1 && (
        <h5 className="py-5 fw-bold text-center" data-aos="zoom-in">
          No payment records
        </h5>
      )}

      {!loader && unpaid.length > 0 && (
        <div data-aos="zoom-in">
          <List>
            {unpaid.map((items, i) => {
              let item = items[0];
              return (
                <List.Item extra={item.bill_amount}>
                  {item.bill_no} - {momentDate(item.bill_date, "DD-MM-YYYY")}
                </List.Item>
              );
            })}
          </List>
        </div>
      )}
    </>
  );
};
export default PaymentHistory;
